import PropTypes from 'prop-types';
import { PICKUP, DROPOFF, RETURN } from './constants';

export const regionPropTypes = PropTypes.shape({
  centerLat: PropTypes.string.isRequired,
  centerLon: PropTypes.string.isRequired,
  phoneCountryCode: PropTypes.string.isRequired,
  supportPhoneNumber: PropTypes.string.isRequired,
});

export const customizationsPropTypes = PropTypes.shape({
  name: PropTypes.string.isRequired,
  supportPhone: PropTypes.string,
  logoUrl: PropTypes.string,
});

export const locationPropTypes = PropTypes.shape({
  name: PropTypes.string,
  address1: PropTypes.string.isRequired,
  address2: PropTypes.string.isRequired,
});

export const waypointPropTypes = PropTypes.shape({
  id: PropTypes.number.isRequired,
  finishedAt: PropTypes.string,
  state: PropTypes.string.isRequired, // waypoint.state of the main waypoint
  waypointType: PropTypes.oneOf([PICKUP, DROPOFF, RETURN]).isRequired,
  location: locationPropTypes.isRequired,
});

export const orderPropTypes = PropTypes.shape({
  eta: PropTypes.number,
  orderId: PropTypes.string.isRequired,
  quiqee: PropTypes.objectOf(PropTypes.string),
  numberOfWaypointsAhead: PropTypes.number.isRequired,
  waypoint: waypointPropTypes,
  region: regionPropTypes,
});



// WEBPACK FOOTER //
// ./src/utils/prop-types.js